import React from "react";
import { motion } from "framer-motion";

const CarouselComponent = () => {
  return (
    <div
      id="carouselExampleInterval"
      className="carousel slide position-relative"
      data-bs-ride="carousel"
      style={{ overflow: "hidden" }}
    >
      <div className="carousel-inner">

        <div className="carousel-item active" data-bs-interval="5000">
          <img
            src="img/main2.jpg"
            className="d-block w-100 hero-img"
            alt="Slide 1"
            style={{ filter: "brightness(70%)" }}
          />
        </div>

        <div className="carousel-item" data-bs-interval="5000">
          <img
            src="img/about3.jpg"
            className="d-block w-100 hero-img"
            alt="Slide 2"
            style={{ filter: "brightness(70%)" }}
          />
        </div>

        <div className="carousel-item" data-bs-interval="5000">
          <img
            src="img/main1.jpg"
            className="d-block w-100 hero-img"
            alt="Slide 3"
            style={{ filter: "brightness(70%)" }}
          />
        </div>

      </div>

      <motion.div
        className="hero-overlay position-absolute top-50 start-50 translate-middle text-center text-white"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
        style={{
          background: "rgba(0,0,0,0.55)",
          backdropFilter: "blur(6px)",
          padding: "30px",
          borderRadius: "16px",
          maxWidth: "600px",
          marginTop:"75px"
        }}
      >
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          style={{
            color: "#f4a261",
            fontWeight: "700",
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}
        >
          Capturing
        </motion.h2>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          style={{
            color: "#fff",
            fontWeight: "700",
            fontSize: "2rem",
            textTransform: "uppercase",
          }}
        >
          Moments of Change
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          style={{ color: "#e0e0e0", lineHeight: "1.6" }}
        >
          Discover the art of filmmaking with <strong>Hanuman Action & Art</strong>.
          <br />
          Connect with us today.
        </motion.p>

        <motion.a
          href="#contact"
          className="btn"
          whileHover={{
            scale: 1.08,
            backgroundColor: "#e76f51",
            boxShadow: "0px 0px 15px rgba(247, 127, 0, 0.6)",
          }}
          whileTap={{ scale: 0.95 }}
          style={{
            backgroundColor: "#f4a261",
            color: "#fff",
            borderRadius: "8px",
            padding: "10px 28px",
          }}
        >
          Contact Us
        </motion.a>
      </motion.div>

      {/* Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleInterval"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon"></span>
        <span className="visually-hidden">Previous</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleInterval"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default CarouselComponent;
